import { ApiRequestError } from '@/lib/api';

interface FlattenedZodError {
  formErrors?: string[];
  fieldErrors?: Record<string, string[] | undefined>;
}

/**
 * Turn an API failure into one clear, user-facing line for the auth forms.
 *
 * A `validation_error` carries the zod `flattenError` output in `details` — we
 * surface the first field/form message (e.g. "Use at least 10 characters.")
 * rather than the generic "The request body is invalid." envelope text.
 */
export function authErrorMessage(
  e: unknown,
  fallback = 'Something went wrong. Try again.',
): string {
  if (!(e instanceof ApiRequestError)) return fallback;

  if (e.code === 'validation_error' && e.details && typeof e.details === 'object') {
    const { fieldErrors, formErrors } = e.details as FlattenedZodError;
    const firstField = fieldErrors && Object.values(fieldErrors).flat().find(Boolean);
    if (firstField) return firstField;
    const firstForm = formErrors?.find(Boolean);
    if (firstForm) return firstForm;
  }

  return e.message || fallback;
}
